import { render } from "./EmailPasswordForm.vue?vue&type=template&id=a9085120&scoped=true"
import script from "./EmailPasswordForm.vue?vue&type=script&lang=js"
export * from "./EmailPasswordForm.vue?vue&type=script&lang=js"

import "./EmailPasswordForm.vue?vue&type=style&index=0&id=a9085120&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9085120"]])

export default __exports__